import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-help',
  template: `
    <i class="pi pi-question-circle help" tooltipPosition="bottom" pTooltip="{{ message }}"></i>
  `,
  styles: [
    `
      .help {
        margin: 0 10px 0 10px;
      }
    `,
  ],
})
export class HelpComponent {
  @Input() message: string = '';

  constructor() {}
}
